import { Box, Text } from '@nimbus-ds/components';
import { Stack } from 'commons/components';
import { ShowHideAmountsIcon } from '../ShowHideAmountsIcon';

// Imitation of nimbus <Tag> element for only one tab for cosmetic consistency
interface TablikeProps {
  label: React.ReactNode;
  children: React.ReactNode;
  eyeOff: boolean;
  onHideAmounts: () => void;
}

function Tablike({
  label,
  children,
  eyeOff,
  onHideAmounts,
}: Readonly<TablikeProps>) {
  return (
    <Stack column align="stretch" spacing="tight">
      <Box
        marginBottom="2"
        borderColor="neutral-surfaceHighlight"
        borderBottomWidth="2"
        borderStyle="solid"
      >
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Text>
            <div style={{ lineHeight: '32px' }}>{label}</div>
          </Text>
          <ShowHideAmountsIcon eyeOff={eyeOff} onClick={onHideAmounts} />
        </Box>
      </Box>
      {children}
    </Stack>
  );
}

export default Tablike;
